export const holidayVI = {
    "holidaySider": {
        "headingLabel": "Quản lý ngày nghỉ",
        "information": "Thông Tin Chung",
        "listHoliday": "Danh sách kỳ nghỉ"
    },
    "holidayTitle": {
        "dayOff": "Ngày nghỉ",
        "type": "Loại ngày nghỉ",
        "reason": "Lí do nghỉ",
        "isTimeKeeping": "Tính công",
        "repeat": "Lặp",
        "startTime": "Giờ bắt đầu",
        "endTime": "Giờ kết thúc",
        "department": "Phòng ban",
        "position": "Vị trí",
        "ceator": "Người tạo"
    },
    "holidayType": {
        "0": "Nghỉ lễ",
        "1": "Nghỉ sự kiện, nghỉ bù",
        "2": "Nghỉ bất thường"
    },
    "holidayMenu": {
        "addHoliday": "Thêm Kì nghỉ",
        "editHoliday": "Sửa Kì nghỉ",
        "deleteHoliday": "Xóa Kì nghỉ"
    },
    "tabHoliday": {
        "type0": "Nghỉ lễ",
        "type1": "Nghỉ sự kiện, nghỉ bù",
        "type2": "Nghỉ bất thường"
    },
    "holidayPalacehodel": {
        "reason": "Nhập lý do nghỉ",
        "type": "Chọn loại ngày nghỉ",
        "department": "Tất cả",
        "position": "Tất cả",
        "yes" : "Có",
        "no" : "Không"
    },
    "holidayRequired": {
        "reason": "Vui lòng nhập lý do nghỉ!",
        "type": "Vui lòng chọn loại ngày nghỉ!",
        "department": "Vui lòng chọn phòng ban!",
        "position": "Vui lòng chọn vị trí!",
        "dayOff": "Vui lòng chọn ngày nghỉ!",
        "isTimeKeeping": "Vui lòng chọn!"
    }
}